import { render, staticRenderFns } from "./configured-competitors-list.vue?vue&type=template&id=7d646738&"
import script from "./configured-competitors-list.vue?vue&type=script&lang=js&"
export * from "./configured-competitors-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports